const careerCenterSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Exploring Your University Career Center</h3>
      <ul className="list-disc pl-6">
        <li>Career centers help students with job applications and career planning.</li>
        <li>They offer valuable resources to support students in their job search.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Services Offered</h3>
      <ul className="list-disc pl-6">
        <li>Resume and cover letter reviews by career counselors.</li>
        <li>Mock interviews and interview preparation workshops.</li>
        <li>Career fairs and networking opportunities with employers.</li>
        <li>Guidance on job search strategies and LinkedIn profile optimization.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Making the Most of Career Resources</h3>
      <ul className="list-disc pl-6">
        <li>Schedule one-on-one appointments for personalized career advice.</li>
        <li>Attend career fairs to meet recruiters and explore job opportunities.</li>
        <li>Take advantage of career workshops to build confidence in your job search.</li>
        <li>Explore online resources provided by your career center.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Overcoming Common Concerns</h3>
      <ul className="list-disc pl-6">
        <li>
          Walking into the career center might feel intimidating, but their purpose is to support
          students.
        </li>
        <li>
          Many services are available online, so check your career center’s website for details.
        </li>
        <li>
          Since these resources are included in tuition, using them early can be a huge advantage.
        </li>
      </ul>
    </div>
  </div>
);

export default careerCenterSummary;
